import { IDeleteReajusteUseCase } from "../../../presentation/useCases/delete/delete_reajuste_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteReajusteUseCase
 */

export class DeleteReajusteUseCase implements IDeleteReajusteUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteReajuste(idReajuste: number): Promise<void> {
    await this.repository.deleteReajuste(idReajuste);

  }
}
